import { IRequest } from '@r1-frontend/shared/types/IRequest';

export interface IGetMerchantInfoResponseDto {
    gateway: string,
    gatewayMerchantId: string,
    samsungService: string,
    merchantId: string,
}

/**
 * Платежная информация. Доступность эквайрингов.
 * https://master.api-profile.sandbox.d2c.r-one.io/docs/v1#/%D0%9F%D0%BB%D0%B0%D1%82%D1%91%D0%B6%D0%BD%D0%B0%D1%8F%20%D0%B8%D0%BD%D1%84%D0%BE%D1%80%D0%BC%D0%B0%D1%86%D0%B8%D1%8F/94052a780f3d251b21ef4cb91fc8050d
 */
export const getMerchantInfo = (): IRequest => ({
    uri: '/v1/pay-list/acquiring-seamless-pay-gw-list',
    method: 'GET',
    withProvider: true,
    withAuth: false,
});
